module.exports = __webpack_public_path__ + "img/4.fc1c7a39.png";